import { IFileSecuritySettings } from 'src/app/interfaces/io/file-security-settings.interface';
import { IFile } from 'src/app/interfaces/io/file.interface';
import { IFileProperties } from 'src/app/interfaces/io/file.properties.interface';

export class FileModel implements IFile {
  path: string;
  icon: string;
  size: number;
  security?: IFileSecuritySettings;
  properties: IFileProperties;

  constructor(base?: IFile | any) {
    this.setDefaultSecuritySettings();

    if (base) {
      Object.assign(this, base);

      if (!this.icon && this.properties && this.properties.isDirectory) {
        this.icon = "folder";
      }
    }
  }

  getName(): string {
    const p = this.path.split("/");
    let name = p[p.length - 1].trim();
    if (name.includes(".")) {
      name = name.substr(0, name.indexOf("."));
    }
    return name;
  }

  private setDefaultSecuritySettings() {
    this.security = {
      authentication: false,
      readOnly: false
    };
  }
}
